import React, { Component } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import ProposalMergeFields from "../../../MergeFields.jsx";

const messages = defineMessages({
    "contact_label": {
        id: 'custom.fields.contact_label',
        defaultMessage: 'Contact',
    },
})

class CustomFormContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function () { },
            customFields: [],
            selectedCustomField: content || {
                customFieldId: '',
                customFieldLabel: '',
                customFieldColSize: "12",
                customFieldType: '',
                customFieldRequired: false,
            }
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.isPriceListProposal = this.isPriceListProposal.bind(this)
        this.getSelectedCustomFormSections = this.getSelectedCustomFormSections.bind(this)
    }

    triggerChanged() {
        this.state.onChange(this.state.selectedCustomField)
    }

    isPriceListProposal() {
        return this.props.variables.proposalType === "price-list"
    }

    isTemplatePriceList() {
        return this.props.variables.quote.title === "Sample"
    }

    normalizeProposalType(proposalType) {
        if (proposalType.charAt(proposalType.length - 1) !== 's') {
            return `${proposalType}s`
        }
        return proposalType
    }

    getProposalType() {
        if (this.isPriceListProposal() && !this.isTemplatePriceList()) {
            return this.normalizeProposalType(this.props.variables.quote.objectType)
        }
        return this.normalizeProposalType(this.state.variables.proposalType)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/custom-field-definitions').then(r => {

            let customFields = []
            let proposalType = this.getProposalType()

            for (let def of r.data) {
                let newDef = JSON.parse(JSON.stringify(def))
                const isCustomFieldAvailableForProposalType = ProposalMergeFields.includeDefinition(def, proposalType)
                newDef.attributes["customFieldType"] = "document"
                if ((isCustomFieldAvailableForProposalType || !this.state.variables.proposalType) &&
                    (!this.isInUse(newDef) || this.isSelected(newDef))) {
                    customFields.push(newDef)
                }

                const isCustomFieldFromContact = ProposalMergeFields.includeDefinitionInContact(def)
                if (!this.isPriceListProposal() && isCustomFieldFromContact) {
                    let contactDefAttributes = Object.assign({}, def.attributes);
                    contactDefAttributes["name"] = this.props.intl.formatMessage(messages["contact_label"]) + " " + def.attributes.name.slice()
                    contactDefAttributes["customFieldType"] = "contact"
                    let contactDef = Object.assign({}, def)
                    contactDef.attributes = contactDefAttributes
                    if (!this.isInUse(contactDef) || this.isSelected(contactDef)) {
                        customFields.push(contactDef)
                    }
                }
            }

            let initialCustomField = {}
            if (this.props.value.customFieldId) {
                const content = this.props.value
                initialCustomField = {
                    customFieldId: content.customFieldId,
                    customFieldLabel: content.customFieldLabel,
                    customFieldColSize: "12",
                    customFieldType: content.customFieldType,
                }
            } else if (customFields.length > 0 && !initialCustomField.customFieldId) {
                const firstDef = customFields[0]
                initialCustomField = {
                    customFieldId: firstDef.id,
                    customFieldLabel: firstDef.attributes.name,
                    customFieldColSize: "12",
                    customFieldType: firstDef.attributes.customFieldType,
                }
            }

            this.setState({
                customFields: customFields,
                selectedCustomField: initialCustomField,
            }, this.triggerChanged)
        })
    }

    isInUse(def) {
        return this.getSelectedCustomFormSections().filter(sec =>
            sec.attributes.content.customField.id === def.id &&
            sec.attributes.content.customFieldType ===
            def.attributes.customFieldType).length > 0
    }

    isSelected(def) {
        return this.state.selectedCustomField.customField && this.state.selectedCustomField.customField.id === def.id &&
            this.state.selectedCustomField.customFieldType === def.attributes.customFieldType
    }

    getSelectedCustomFormSections() {
        return this.state.variables.sections.filter(x =>
            x.attributes.contentType === "custom-form")
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value;

        let selectedCustomField = Object.assign({}, this.state.selectedCustomField)
        selectedCustomField[target.name] = value

        if (target.name === "customFieldId") {
            selectedCustomField.customFieldId = target.value.substring(target.value.indexOf("-") + 1)
            selectedCustomField.customFieldType = target.value.substring(0, target.value.indexOf("-"))
        }
        if (target.name !== "customFieldLabel") {
            selectedCustomField.customFieldLabel
                = this.state.customFields.find(cf => cf.id === selectedCustomField.customFieldId && cf.attributes.customFieldType === selectedCustomField.customFieldType).attributes.name
        }

        this.setState({
            selectedCustomField,
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="mb-0 col-3">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.custom_form.select_label"
                            defaultMessage="Select custom field"
                        />
                    </label>
                    <div className="col-9">
                        <select value={this.state.selectedCustomField.customFieldType + "-" + this.state.selectedCustomField.customFieldId}
                            className="custom-select mr-1"
                            id="customFieldId"
                            name="customFieldId"
                            onChange={this.handleFormChange}>
                            {
                                this.state.customFields.map(customField => {
                                    return <option value={customField.attributes.customFieldType + "-" + customField.id}>
                                        {customField.attributes.name}
                                    </option>
                                })
                            }
                        </select>
                    </div>
                </div>


                <div className="form-group row">
                    <label className="col-3 mb-0">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.custom_form.name_label"
                            defaultMessage="Displayed text"
                        />
                    </label>
                    <div className="col-9">
                        <input
                            name="customFieldLabel"
                            value={this.state.selectedCustomField.customFieldLabel}
                            onChange={(event) => this.handleFormChange(event)}
                            id="customFieldLabel"
                            type="text"
                            className="form-control"
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.custom_form.name_description"
                                defaultMessage="The text that will appear on the document for this custom field"
                            />
                        </small>
                    </div>
                </div>

                <div className="form-group row">
                    <label className="mb-0 col-3">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.custom_form.width_label"
                            defaultMessage="Field width"
                        />
                    </label>
                    <div className="col-9">
                        <input
                            min="1"
                            max="12"
                            name="customFieldColSize"
                            value={this.state.selectedCustomField.customFieldColSize}
                            onChange={(event) => this.handleFormChange(event)}
                            id="customFieldColSize"
                            type="number"
                            className="form-control"
                            placeholder="12"
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.custom_form.width_description"
                                defaultMessage="The width that this field will take. 12 is full width and 6 is half."
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="mb-0 col-3">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.custom_form.is_required_label"
                            defaultMessage="Required"
                        />
                    </label>

                    <div className="col-9">
                        <input
                            type="checkbox"
                            id="customFieldRequired"
                            name="customFieldRequired"
                            checked={this.state.selectedCustomField.customFieldRequired}
                            value={this.state.selectedCustomField.customFieldRequired}
                            onChange={(event) => this.handleFormChange(event)}
                        />
                    </div>
                </div>
            </div >
        );
    }
}

export default injectIntl(CustomFormContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/custom-form/input.component.jsx